import request from '@/api/request.js'; //请求对象
 
 const apis = {
	
	delete (params){
		return request({url: `/admin_find_sound/delete`, method: 'POST', data:params})
	},
	ReadOnlineCountLog (params){
		return request({url: `/admin_index/ReadOnlineCountLog`, params:params, method: 'GET'})
	},
	getOnlineDataPersent (params){
		return request({url: `/admin_index/getOnlineDataPersent`, params:params, method: 'GET'})
	},
	// 2026-10-07：近期音效行为独立读取；新列表故障不影响现有运营总览。
	getSoundActivity (params){
		return request({url: `/admin_index/getSoundActivity`, params:params, method: 'GET'})
	},
	answer (params){
		return request({url: `/admin_find_sound/answer`, params:params, method: 'POST'})
	},
 }
 
 export default apis;
